import React from "react";

import {Link} from "react-router-dom";
import moment from "moment";
import {Badge, Button, Popconfirm, Pagination, Spin} from "antd";
import {orderBy} from "lodash";
import FontAwesome from "react-fontawesome";
import Pie from "components/stateless/Pie";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {Row, Col} from "antd";

import {Loading, showNotification} from "src/components/stateless";
import {fetchPaginatedTransactions} from "src/actions/transactions";

class TransactionsList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      total: 0,
      loading: true,
      page: 1,
      pageSize: 10,
      LinetoExpand: null,
    };
  }

  componentDidMount() {
    this.loadPage(1);
  }

  loadPage = async (page) => {
    this.setState({loading: true});
    try {
      const offset = (page - 1) * this.state.pageSize;
      const result = await fetchPaginatedTransactions(
        this.props.client,
        this.state.pageSize,
        offset,
        this.props.search || ""
      );
      this.setState({
        items: result.items || [],
        total: result.total || 0,
        page,
        loading: false,
      });
    } catch (err) {
      this.setState({loading: false});
      showNotification("error", "Erreur", "Impossible de charger les transactions");
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      this.loadPage(1);
    }
  }

  onPageChange = (page) => {
    this.loadPage(page);
  };

  onPageSizeChange = (current, size) => {
    this.setState({pageSize: size}, () => this.loadPage(1));
  };

  render() {
    const {items, total, loading, page, pageSize} = this.state;
    const {user} = this.props;

    if (loading && items.length === 0) return <Loading />;

    let transactionsList = items;
    if (user.role.name !== "Admin") {
      transactionsList = items.filter(t =>
        t.user.id === user.id || t.beneficiaries.find(u => u.user.id === user.id)
      );
    }

    const list = transactionsList.map(curr => ({
      ...curr,
      user: `${curr.user.firstname} ${curr.user.lastname}`,
      userId: curr.user.id,
      date: moment(curr.createdAt).format("DD/MM/YYYY HH:mm:ss"),
      view: (
        <Button type="primary" onClick={() => this.props.onEditClicked(curr.id)}>
          <i className="fa fa-eye" />
        </Button>
      ),
      commissionAmount: curr.commissionAmount + " €",
      prescriptors: curr.hasPrescriptor ? (
        <div>
          <span>
            <FontAwesome name="sign-in-alt" style={{color: "#1890ff"}} />
            Entrant:
            {curr.inputPrescriptor
              ? ` ${curr.inputPrescriptor.firstname} ${curr.inputPrescriptor.lastname}`
              : " Aucun"}
          </span>
          <br />
          <span>
            <FontAwesome name="sign-out-alt" style={{color: "rgb(88, 196, 26)"}} />
            Sortant:
            {curr.outputPrescriptor
              ? ` ${curr.outputPrescriptor.firstname} ${curr.outputPrescriptor.lastname}`
              : " Aucun"}
          </span>
        </div>
      ) : "Aucun",
      recommandations: curr.hasRecommandation ? (
        <div>
          <span>
            <FontAwesome name="sign-in-alt" style={{color: "#1890ff"}} />
            Entrante:
            {curr.inputRecommandator
              ? ` ${curr.inputRecommandator.firstname} ${curr.inputRecommandator.lastname}`
              : " Aucune"}
          </span>
          <br />
          <span>
            <FontAwesome name="sign-out-alt" style={{color: "rgb(88, 196, 26)"}} />
            Sortante:
            {curr.outputRecommandator
              ? ` ${curr.outputRecommandator.firstname} ${curr.outputRecommandator.lastname}`
              : " Aucune"}
          </span>
        </div>
      ) : "Aucune",
      mandat: (
        <div>
          <span>
            <FontAwesome name="sign-in-alt" style={{color: "#1890ff"}} />
            Entrant:
            {curr.representativeInput
              ? ` ${curr.representativeInput.firstname} ${curr.representativeInput.lastname}`
              : " Aucun"}
          </span>
          <br />
          <span>
            <FontAwesome name="sign-out-alt" style={{color: "rgb(159, 196, 26)"}} />
            Sortant:
            {curr.user
              ? ` ${curr.user.firstname} ${curr.user.lastname}`
              : " Aucun"}
          </span>
        </div>
      ),
      delete: (
        <Popconfirm
          title={"Voulez-vous vraiment supprimer cette transaction ?"}
          icon={<QuestionCircleOutlined style={{color: "red"}} />}
          onConfirm={() => this.props.onDeleteClicked(curr.id)}
          okText="Oui"
          cancelText="Annuler"
        >
          <Button type="primary" danger>
            <i className="fa fa-trash" />
          </Button>
        </Popconfirm>
      ),
    }));

    const expandRow = {
      renderer: row => {
        let oAmount = 0;
        let rAmount = 0;
        const data = orderBy(row.beneficiaries, r => r.amount, "desc").reduce(
          (c, n) => {
            if (n.level > 0) {
              if (c.repartition[n.user.id]) {
                c.repartition[n.user.id].value += n.user.needTva
                  ? n.amount - n.vatAmount
                  : n.amount;
              } else {
                c.repartition[n.user.id] = {
                  value: n.user.needTva ? n.amount - n.vatAmount : n.amount,
                  type: `${n.user.firstname} ${n.user.lastname}`,
                };
              }
              rAmount += n.user.needTva ? n.amount - n.vatAmount : n.amount;
            } else {
              if (c.others[n.user.id]) {
                c.others[n.user.id].value += n.user.needTva
                  ? n.amount - n.vatAmount
                  : n.amount;
              } else {
                c.others[n.user.id] = {
                  value: n.user.needTva ? n.amount - n.vatAmount : n.amount,
                  type: `${n.user.firstname} ${n.user.lastname}`,
                };
              }
              oAmount += n.user.needTva ? n.amount - n.vatAmount : n.amount;
            }
            return c;
          },
          {repartition: {}, others: {}}
        );

        const olist = Object.keys(data.others).map(i => data.others[i]);
        const rlist = Object.keys(data.repartition).map(i => data.repartition[i]);
        return (
          <>
            <div style={{width: "50%", float: "left", minHeight: 400}}>
              <Pie data={olist} title={"Honoraires"} content={`${oAmount} €`} />
            </div>
            <div
              style={{
                width: "50%", float: "right", textAlign: "center", minHeight: 400,
                display: rlist.length ? "block" : "flex",
                justifyContent: "center", alignItems: "center",
              }}
            >
              {rlist.length ? (
                <Pie data={rlist} title={"Répartitions"} content={`${rAmount} €`} />
              ) : (
                <h5>Aucune répartition sur cette transaction</h5>
              )}
            </div>
          </>
        );
      },
      onlyOneExpanding: true,
      expandByColumnOnly: true,
      showExpandColumn: true,
      expandColumnPosition: "right",
      expandHeaderColumnRenderer: () => <b style={{fontWeight: 700}}>Bénéficiaires</b>,
      expandColumnRenderer: ({expanded}) => (
        <FontAwesome
          name="chart-pie"
          style={{
            color: expanded ? "#F1AF1D" : "#0BAC4C",
            fontSize: 32, display: "flex", justifyContent: "center",
          }}
        />
      ),
    };

    // Use react-bootstrap-table for display (no remote pagination — we control data)
    const BootstrapTable = require("react-bootstrap-table-next").default;

    const columns = [
      {dataField: "view", text: "", headerStyle: () => ({width: 28})},
      {dataField: "delete", text: "", headerStyle: () => ({width: 28})},
      {dataField: "nettyId", text: "Id du bien netty"},
      {dataField: "user", text: "Crée par"},
      {dataField: "date", text: "Date"},
      {dataField: "commissionAmountHt", text: "Commission (HT)", formatter: e => `${parseFloat(e).toFixed(2)} €`},
      {dataField: "mandat", text: "Mandat"},
      {dataField: "prescriptors", text: "Prescripteurs"},
      {dataField: "recommandations", text: "Recommandations"},
    ];

    return (
      <div className="card">
        <Spin spinning={loading}>
          <BootstrapTable
            keyField="id"
            data={list}
            columns={columns}
            bootstrap4
            hover
            expandRow={expandRow}
            noDataIndication={() => <div>Aucun résultat...</div>}
            wrapperClasses="table-responsive"
          />
        </Spin>
        <div style={{display: "flex", justifyContent: "flex-end", padding: "12px 0"}}>
          <Pagination
            current={page}
            total={total}
            pageSize={pageSize}
            onChange={this.onPageChange}
            onShowSizeChange={this.onPageSizeChange}
            showSizeChanger
            showTotal={(total) => `${total} transactions`}
            pageSizeOptions={["10", "25", "50", "100"]}
          />
        </div>
      </div>
    );
  }
}

export default TransactionsList;
